module.exports = __webpack_public_path__ + "img/activate.642ce5c.svg";